import { handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import { RESOURCE_TYPES } from 'shared/constants/sms-consent';
import { GET_SMS_INFO, GET_USER_SMS_STATE } from '../actions/sms-consent-actions'

const { SUCCESS } = httpActions;
const { ADD_VERBIAGE, TITLE } = RESOURCE_TYPES;

export const initialState = {
  smsUuid: '',
  smsVerbiage: '',
  smsSecondaryVerbiage: '',
  smsTitle: '',
  previousOptState: null,
};

const reducer = handleActions(
  {
    [`${GET_SMS_INFO}_${SUCCESS}`](state = initialState, action) {
      if (!action.payload) {
        return state;
      }
      const result = {
        ...state,
        smsUuid: action.payload.uuid,
        smsVerbiage: action.payload.verbiage,
      };
      if (action.payload.resources?.length) {
        result.smsSecondaryVerbiage = action.payload.resources.find(({ type }) => type === ADD_VERBIAGE)?.value;
      }
      if (action.payload.resources?.length) {
        result.smsTitle = action.payload.resources.find(({ type }) => type === TITLE)?.value;
      }
      return result;
    },
    [`${GET_USER_SMS_STATE}_${SUCCESS}`](state = initialState, action) {
      return {
        ...state,
        previousOptState: action.payload,
      };
    },
  },
  initialState
);

export default reducer;
